import { render, staticRenderFns } from "./mobile_hecoos_server.vue?vue&type=template&id=67f1a3d6&scoped=true"
import script from "./mobile_hecoos_server.vue?vue&type=script&lang=js"
export * from "./mobile_hecoos_server.vue?vue&type=script&lang=js"
import style0 from "./mobile_hecoos_server.vue?vue&type=style&index=0&id=67f1a3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f1a3d6",
  null
  
)

export default component.exports